import { Typography } from '@mui/material';
import React from 'react';

const CenteredImage = ({ imageUrl, altText = 'Image' }) => {
  return (
   <div
   style={{
     display: 'flex',
     flexDirection: 'column',
     justifyContent: 'center',
     alignItems: 'center',
     height: '100vh',
     width: '100vw',
    }}
    >
    {/* <Typography variant="h4">העמוד בעבודה</Typography> */}
   <img
     src={'/SiteUnderConstruction2.jpeg'}
     alt={altText}
     style={{
       maxWidth: '60%',
       maxHeight: '60%',
       objectFit: 'contain',
     }}
   />
   {/* <p style={{ marginTop: '20px', fontSize: '1.5rem', textAlign: 'center' }}>העמוד בעבודה</p> */}
 </div>
    // <div
    //   style={{
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     height: '100vh',
    //     width: '100vw',
    //   }}
    // >
    //   <img
    //     src={'/images/workerPageImg.webp'}
    //     alt={altText}
    //     style={{
    //       maxWidth: '100%',
    //       maxHeight: '100%',
    //       objectFit: 'contain',
    //     }}
    //   />
    // </div>
  );
};

export default CenteredImage;